module.exports = __webpack_public_path__ + "static/img/20017 (3).ff40b31.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (3).webp
// module id = xx/q
// module chunks = 14